"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxButton = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../../../../../icons");
var themes_1 = require("../../../../../../themes");
var styled_1 = require("./styled");
var Check = icons_1.icons.Check;
var white = themes_1.colors.white, greyColor100 = themes_1.colors.greyColor100;
/**
 * value and onChange are being passed as props so
 * that it can be generated dynamically via our
 * block generators.
 */
var CheckboxButton = function (_a) {
    var _b;
    var id = _a.id, className = _a.className, _isSelected = _a.isSelected, value = _a.value, //can be used interchangibly
    onChange = _a.onChange, disabled = _a.disabled, invert = _a.invert, S = _a.S;
    var isSelected = (_b = _isSelected !== null && _isSelected !== void 0 ? _isSelected : value) !== null && _b !== void 0 ? _b : false;
    return (react_1.default.createElement(styled_1.StyledCheckbox, { onClick: function (e) {
            // e.preventDefault();
            // e.stopPropagation(); //this disables the checkbox in checkboxlist which we dont want. so commented. tho we might need this later in table usecase in which case we will have to make stopPropagration a prop
            onChange && onChange(id, !isSelected);
        }, className: className, isSelected: isSelected, disabled: disabled, invert: invert, S: S }, isSelected &&
        react_1.default.createElement(Check, { weight: "bold", color: invert ? greyColor100 : white, size: 16, style: { flexShrink: 0 } })));
};
exports.CheckboxButton = CheckboxButton;
